import { create } from 'zustand';

/**
 * Critical Error Store
 * Manages critical system errors that require user attention
 * When active, puts the game in "standby mode" - visible but non-interactive
 */
const useCriticalErrorStore = create((set, get) => ({
  // --- STATE ---
  hasCriticalError: false,
  errorMessage: null,
  errorDetails: null, // Array of detailed error info for debugging
  errorSource: null,  // Where the error originated (e.g., 'unitValidator', 'api')

  // --- ACTIONS ---

  /**
   * Set a critical error - puts system in standby mode
   * @param {string} message - User-friendly error message
   * @param {object} options - Additional options
   * @param {string} options.source - Error source identifier
   * @param {Array} options.details - Detailed error information
   */
  setCriticalError: (message, options = {}) => {
    const { source = 'unknown', details = null } = options;

    // Only set if not already in error state (prevent spam)
    if (!get().hasCriticalError) {
      console.error(`[CriticalError] ${source}: ${message}`, details);
      set({
        hasCriticalError: true,
        errorMessage: message,
        errorDetails: details,
        errorSource: source
      });
    }
  },

  /**
   * Clear the critical error - returns system to normal mode
   */
  clearCriticalError: () => {
    set({
      hasCriticalError: false,
      errorMessage: null,
      errorDetails: null,
      errorSource: null
    });
  },

  /**
   * Check if system is in standby mode (has critical error)
   * @returns {boolean}
   */
  isInStandbyMode: () => get().hasCriticalError,
}));

export default useCriticalErrorStore;
